module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('page-title', {
    attrs: {
      "title": _vm.title
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "1000px"
    }
  }, [_c('object', {
    attrs: {
      "data": _vm.pdfLink,
      "height": "100%",
      "width": "100%",
      "type": "application/pdf"
    }
  }, [_c('p', [_vm._v("This browser does not support PDFs. Please download the PDF to view it: \n"), _c('a', {
    attrs: {
      "href": _vm.pdfLink
    }
  }, [_vm._v("Download PDF")]), _vm._v(".")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a6006e3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Resume.vue
// module id = 75
// module chunks = 0